export default __webpack_public_path__ + "static/media/lieferheld_s1.eba2efb0.png";